<template>
  <!-- The shell's toast (shell/toast.js): bottom centre, above the player. -->
  <v-snackbar
    v-model="state.show"
    :timeout="state.timeout"
    location="bottom"
    color="var(--cl-toast)"
    class="shell-toast"
    :style="{ '--toast-lift': 'var(--cl-player-h, 0px)' }"
  >
    {{ state.text }}
    <template v-if="state.action" #actions>
      <v-btn variant="text" color="var(--cl-accent-text)" @click="act">{{ state.action.label }}</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { toastState } from "./toast.js";

export default {
  name: "ToastHost",
  data: () => ({ state: toastState }),
  methods: {
    act() {
      const a = this.state.action;
      this.state.show = false;
      if (a && a.onClick) a.onClick();
    },
  },
};
</script>

<style>
.shell-toast .v-snackbar__wrapper {
  margin-bottom: calc(12px + var(--cl-player-h, 0px));
}
</style>
